import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RoutingService {
  constructor(
    private _router: Router,
  ) {

  }

  public home() {
    this._router.navigate(['/']);
  }

  public login() {
    this._router.navigate(['/login']);
  }

  public travel() {
    this._router.navigate(['/travel']);
  }

  public news() {
    this._router.navigate(['/news']);
  }

  public video() {
    this._router.navigate(['/video']);
  }

  public dashboard() {
    this._router.navigate(['/finance']);
  }

  public profile() {
    this._router.navigate(['/profile']);
  }
}
